if (!customElements.get('variant-customizer')) {
  customElements.define(
    'variant-customizer',
    class VariantCustomizer extends HTMLElement {
      constructor() {
        super();
        this.mainForm = this.closest('section').querySelector('product-form form[action*="/cart/add"]');

        this.customizeBtn = this.querySelector('#variant-customizer_btn');
        this.customizeBtnCheck = this.querySelector('input');
        this.customizationContainer = this.querySelector('#variant-customizer_container');
        this.isOpen = false;

        this.textInput = this.querySelector('input[id="texte"]');
        // this.fontNativeSelector = this.querySelector('select[id="typographie"]');
        this.fontCustomSelector = this.querySelector('#variant-customizer_text-font-select');
        this.orientationSelector = this.querySelector('select[id="orientation"]');

        this.textInputValue = this.textInput.value;
        this.selectedFont = this.querySelector('#variant-customizer_text-font-select .selected-option').getAttribute('data-value');
        this.selectedFontName = this.querySelector('#variant-customizer_text-font-select .selected-option').getAttribute('data-font');
        this.selectedOrientation = this.orientationSelector.value;
        this.selectedOrientationName = this.orientationSelector.options[0].dataset.orientation;

        this.options = this.getSelectedOptions();

        this.textPreview = this.closest('div.product').querySelector('#variant-customizer_text-preview');
        this.previewButton = this.querySelector('.variant-customizer_go-to-preview');

        this.optionValueTrue = this.dataset.optionValueTrue;
        this.optionValueFalse = this.dataset.optionValueFalse;
        this.allowEmojis = this.dataset.allowEmojis;
      }

      connectedCallback() {
        // Si la personne arrive sur la page avec la variante "avec personnalisation" déjà sélectionnée, on ouvre le customizer
        if (this.closest('.product').querySelector('input[value="' + this.optionValueTrue + '"').checked) this.openCustomizer();

        this.initEventListeners();
        this.hideOriginalVariantOption();
        this.setVariantCustomizerVisibility(this.dataset.variantAvailability);
        this.setAddToCartState();
        this.setColor();
        this.setTextColor();
        this.setPropertiesToMainForm();
      }

      initEventListeners() {
        this.customizeBtn.addEventListener('click', () => this.openCustomizer());

        const checkboxElement = this.querySelector('#variant-customizer_checkbox');
        if (checkboxElement) {
          checkboxElement.addEventListener('change', async () => {
            await new Promise((resolve) => setTimeout(resolve, 0));
            this.setCustomizeVariantValue();
            this.setPropertiesToMainForm();
            this.setAddToCartState();
          });
        }

        //Au changement de texte, on met à jour le texte du preview et on met à jour la taille de la police
        if (this.textInput) {
          this.textInput.addEventListener('input', () => {
            if (this.allowEmojis == 'false' && this.textInput.value.match(/[\p{Emoji}]/u) !== null) {
              this.textInput.value = this.textInput.value.replace(/[\p{Emoji}]/gu, '');
            }
            this.onTextChange();
          });
        }

        // Déroule le selecteur de police
        this.fontCustomSelector.querySelector('#variant-customizer_text-font').addEventListener('click', () => {
          this.fontCustomSelector.querySelector('.options').classList.toggle('hidden');
        });

        // Au changement de police, on met à jour la police du texte et on met à jour les propriétés du formulaire
        this.fontCustomSelector.querySelectorAll('.option').forEach((option) => {
          option.addEventListener('click', () => {
            this.onFontChange(option);
          });
        });

        // Une option que j'avais envisagée au début, avec un select natif:
        // this.fontNativeSelector.addEventListener('change', (e) => {
        //   this.selectedFont = e.target.value;
        //   this.selectedFontName = e.target.options[e.target.selectedIndex].dataset.font;
        //   this.textPreview.style.fontFamily = e.target.getAttribute('data-font');
        //   this.onVariantCustomizerChange();
        // });

        // Au changement d'orientation, on met à jour l'orientation du texte et on met à jour les propriétés du formulaire
        this.orientationSelector.addEventListener('change', () => {
          this.onOrientationChange();
        });

        // Au changement de variante
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          this.setVariantCustomizerVisibility(event.data.variant.available);
          this.onVariantChange();
        });

        this.querySelector('.variant-customizer_go-to-preview').addEventListener('click', () => {
          // document.querySelector('.product__media-wrapper').scrollIntoView({ behavior: 'smooth' });
          window.scrollTo({ top: 0, behavior: 'smooth' });
        });

        window.addEventListener('load', () => this.setFontSize());
        window.addEventListener('resize', () => this.setFontSize());
      }

      onVariantCustomizerChange() {
        this.setPropertiesToMainForm();
      }

      onVariantChange() {
        this.hideOriginalVariantOption();
        this.options = this.getSelectedOptions();
        this.setAddToCartState();
        this.setColor();
        this.setTextColor();
      }

      onTextChange() {
        this.textInputValue = this.textInput.value;
        this.textPreview.textContent = this.textInput.value.trim();
        if (this.textInput.value.trim() === '') {
          this.previewButton.classList.add('hidden');
        } else {
          this.previewButton.classList.remove('hidden');
        }
        this.customizationContainer.style.maxHeight = `${this.customizationContainer.scrollHeight}px`;
        this.setFontSize();
        this.setAddToCartState();
        this.setPropertiesToMainForm();
      }

      onFontChange(option) {
        this.selectedFont = option.dataset.value;
        this.selectedFontName = option.dataset.font;
        this.textPreview.style.fontFamily = option.dataset.font;

        this.fontCustomSelector.querySelector('.options').classList.add('hidden');

        const selectedOption = this.fontCustomSelector.querySelector('.selected-option');
        selectedOption.querySelector('.selected-option_text').textContent = option.textContent;
        selectedOption.style.fontFamily = option.dataset.font;
        selectedOption.setAttribute('data-value', option.dataset.value);
        selectedOption.setAttribute('data-font', option.dataset.font);

        this.setFontSize();
        this.setPropertiesToMainForm();
      }

      onOrientationChange() {
        this.selectedOrientation = this.orientationSelector.value;
        this.selectedOrientationName = this.orientationSelector.options[this.orientationSelector.selectedIndex].dataset.orientation;
        this.selectedOrientation == 'vertical' ? this.textPreview.classList.remove('horizontal') : this.textPreview.classList.add('horizontal');

        if (this.selectedOrientation === 'horizontal') {
          this.textInput.maxLength = 20;
          this.textInput.placeholder = '20 caractères maximum';

          if (this.textInput.value.length > 20) {
            this.textInput.value = this.textInput.value.substring(0, 20);
            this.textPreview.textContent = this.textInput.value;
          }
        } else {
          this.textInput.maxLength = 26;
          this.textInput.placeholder = '26 caractères maximum';
        }

        this.setFontSize();
        this.setPropertiesToMainForm();
      }

      openCustomizer() {
        const event = new Event('change');
        if (this.isOpen) {
          this.customizationContainer.style.maxHeight = '0';
          this.querySelector('.variant-customizer_wrapper').classList.remove('isOpen');
          this.customizeBtnCheck.checked = false;
          this.customizeBtnCheck.dispatchEvent(event);
          this.textPreview.style.display = 'none';
        } else {
          this.customizationContainer.style.maxHeight = `${this.customizationContainer.scrollHeight}px`;
          this.querySelector('.variant-customizer_wrapper').classList.add('isOpen');
          this.customizeBtnCheck.checked = true;
          this.customizeBtnCheck.dispatchEvent(event);
          this.textPreview.style.display = 'block';
        }
        this.isOpen = !this.isOpen;

        this.setAddToCartState();
      }

      hideOriginalVariantOption() {
        const optionName = this.dataset.optionName;
        document.querySelectorAll('.form__label').forEach((label) => {
          if (label.textContent === optionName) {
            label.closest('fieldset').classList.add('hidden');
          }
        });
      }

      getSelectedOptions() {
        const variantSelectorElement = this.closest('.product').querySelector('variant-selects');
        return Array.from(variantSelectorElement.querySelectorAll('input:checked'), (checkbox) => checkbox.value);
      }

      setVariantCustomizerVisibility(variant_availability) {
        if (variant_availability == true || variant_availability === 'true') {
          this.querySelector('.variant-customizer_wrapper').style.display = 'block';
        } else {
          this.querySelector('.variant-customizer_wrapper').style.display = 'none';
        }
      }

      setPropertiesToMainForm() {
        this.mainForm.querySelectorAll('.from-variant-customizer').forEach((input) => input.remove());

        if (this.isOpen) {
          this.mainForm.insertAdjacentHTML('beforeend', `<input type="hidden" class="from-variant-customizer" name="properties[text]" value="${this.textInputValue}">`);
          this.mainForm.insertAdjacentHTML('beforeend', `<input type="hidden" class="from-variant-customizer" name="properties[font]" value="${this.selectedFontName}">`);
          this.mainForm.insertAdjacentHTML('beforeend', `<input type="hidden" class="from-variant-customizer" name="properties[orientation]" value="${this.selectedOrientationName}">`);
        }
      }

      setCustomizeVariantValue() {
        const checkboxElement = this.querySelector('#variant-customizer_checkbox');
        if (checkboxElement.checked) {
          this.closest('.product')
            .querySelector('input[value="' + this.optionValueTrue + '"')
            .click();
        } else {
          this.closest('.product')
            .querySelector('input[value="' + this.optionValueFalse + '"')
            .click();
        }
      }

      setAddToCartState() {
        if (this.textInput.value.trim() === '' && this.isOpen) {
          this.mainForm.querySelector('button[type="submit"]').setAttribute('disabled', 'disabled');
          if (this.mainForm.querySelector('sticky-atc-button button') != null) {
            this.mainForm.querySelector('sticky-atc-button button').setAttribute('disabled', 'disabled');
          }
        } else {
          this.mainForm.querySelector('button[type="submit"]').removeAttribute('disabled');
          if (this.mainForm.querySelector('sticky-atc-button button') != null) {
            this.mainForm.querySelector('sticky-atc-button button').removeAttribute('disabled', 'disabled');
          }
        }
      }

      setColor() {
        const colorNameElement = document.querySelector('#variant-option-color');
        if (colorNameElement) {
          colorNameElement.textContent = this.options[0];
        }
      }

      setTextColor() {
        var classes = this.textPreview.classList;
        classes.forEach(function (className) {
          if (className.startsWith('variant-customizer_text-color_')) {
            classes.remove(className);
          }
        });
        classes.add(`variant-customizer_text-color_${this.options[0]}`);
      }

      setFontSize() {
        var parentWidth = document.querySelector('.product__media-wrapper').querySelector('.product__media').offsetWidth;
        var fontSize = 0.04 * parentWidth;
        var fontWeight = 'bold';
        if (this.selectedFont != 'comfortaa' && this.selectedFont != 'times') {
          fontSize = fontSize * 1.1;
          fontWeight = 'normal';
        }
        if (this.selectedFont == 'times') {
          fontSize = fontSize * 0.9;
          fontWeight = 'normal';
        }
        if (this.selectedOrientation == 'horizontal') {
          if (this.textInput.value.length > 10) {
            var reductionFactor = 1.25 + (this.textInput.value.length - 10) * 0.15;
            fontSize = fontSize / reductionFactor;
          } else fontSize = fontSize / 1.25;
        }
        if (this.selectedOrientation == 'vertical') {
          if (this.textInput.value.length > 15) {
            var reductionFactor = 1.25 + (this.textInput.value.length - 15) * 0.02;
            fontSize = fontSize / reductionFactor;
          }
        }
        this.textPreview.style.fontSize = fontSize + 'px';
        this.textPreview.style.fontWeight = fontWeight;
      }
    }
  );
}